var exports = {
  "e6": "ChannelItem.module__channelItemCore___Y1Bia3",
  "$H": "ChannelItem.module__channelItemCoreSelected___Y1Bia3",
  "_B": "ChannelItem.module__channelItemCoreUnselected___Y1Bia3",
  "Vp": "ChannelItem.module__channelItemCoreHovered___Y1Bia3",
  "TV": "ChannelItem.module__typingTooltip___Y1Bia3",
  "kp": "ChannelItem.module__channelTypingIndicator___Y1Bia3",
  "IM": "ChannelItem.module__typingIndicatorIcon___Y1Bia3",
  "U4": "ChannelItem.module__channelItemSelected___Y1Bia3",
  "OI": "ChannelItem.module__typingAvatars___Y1Bia3",
  "_N": "ChannelItem.module__channelItemIcon___Y1Bia3",
  "Jz": "ChannelItem.module__channelItemIconSelected___Y1Bia3",
  "Wk": "ChannelItem.module__categoryContainer___Y1Bia3",
  "yb": "ChannelItem.module__categoryName___Y1Bia3",
  "zc": "ChannelItem.module__iconContainer___Y1Bia3",
  "HA": "ChannelItem.module__channelName___Y1Bia3",
  "Hq": "ChannelItem.module__actionsContainer___Y1Bia3",
  "OO": "ChannelItem.module__channelItemIconUnselected___Y1Bia3",
  "Cr": "ChannelItem.module__channelItemIconHighlight___Y1Bia3",
  "rC": "ChannelItem.module__channelItemLabel___Y1Bia3",
  "gw": "ChannelItem.module__channelItemActions___Y1Bia3",
  "kL": "ChannelItem.module__container___Y1Bia3",
  "YI": "ChannelItem.module__channelReorderTarget___Y1Bia3",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___Y1Bia3",
  "XE": "ChannelItem.module__unreadIndicator___Y1Bia3",
  "_j": "ChannelItem.module__unreadIndicatorMuted___Y1Bia3",
  "fc": "ChannelItem.module__channelItem___Y1Bia3",
  "Z$": "ChannelItem.module__channelItemCategory___Y1Bia3",
  "RQ": "ChannelItem.module__channelItemRegular___Y1Bia3",
  "zx": "ChannelItem.module__channelItemHighlight___Y1Bia3",
  "_R": "ChannelItem.module__channelItemMuted___Y1Bia3",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___Y1Bia3",
  "Fb": "ChannelItem.module__channelItemHoverable___Y1Bia3",
  "FN": "ChannelItem.module__channelItemPressed___Y1Bia3",
  "Je": "ChannelItem.module__channelItemOver___Y1Bia3",
  "X9": "ChannelItem.module__channelItemContextMenu___Y1Bia3",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___Y1Bia3",
  "GJ": "ChannelItem.module__channelItemDragging___Y1Bia3",
  "rO": "ChannelItem.module__channelItemDimmed___Y1Bia3",
  "x1": "ChannelItem.module__channelItemMutedState___Y1Bia3",
  "Ef": "ChannelItem.module__hoverAffordance___Y1Bia3",
  "Mn": "ChannelItem.module__keyboardFocus___Y1Bia3",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___Y1Bia3",
  "Yq": "ChannelItem.module__categoryContent___Y1Bia3",
  "Yl": "ChannelItem.module__categoryIcon___Y1Bia3",
  "Sk": "ChannelItem.module__createChannelButton___Y1Bia3",
  "$Z": "ChannelItem.module__createChannelIcon___Y1Bia3",
  "Ne": "ChannelItem.module__voiceUserCount___Y1Bia3",
  "p9": "ChannelItem.module__channelItemVoice___Y1Bia3",
  "pL": "ChannelItem.module__contextMenuOpen___Y1Bia3",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___Y1Bia3",
};

module.exports = exports;
